<script setup lang="tsx">
import VarsityInlineConfirm from "@/components/VarsityInlineConfirm.vue"
import VarsityInlineConfirmButton from "@/components/VarsityInlineConfirmButton.vue"
import { createInlineConfirm } from "@/composables/createInlineConfirm"
import { useHttpClient } from "@/vf"
import { useI18n } from "vue-i18n"

const props = defineProps<{
    registrationId: string
    viewMode: "admin" | "customer"
}>()

const emit = defineEmits<{
    (e: "resetted"): void
}>()

const http = useHttpClient()
const { t } = useI18n()
const confirm = createInlineConfirm({
    async action() {
        await http.post(`/championship/registration/${props.registrationId}/reset?viewMode=${props.viewMode}`)
    },
    afterAction() {
        emit("resetted")
    },
})

function renderButton() {
    return (
        <VarsityInlineConfirmButton controller={confirm}>
            {t("@tasks:tasks.championship_registration.wizard.reset_registration.button")}
        </VarsityInlineConfirmButton>
    )
}

function renderConfirm() {
    return (
        <VarsityInlineConfirm controller={confirm}>
            {{
                confirmation: () => t("@tasks:tasks.championship_registration.wizard.reset_registration.confirmation"),
                success: () => t("@tasks:tasks.championship_registration.wizard.reset_registration.success"),
            }}
        </VarsityInlineConfirm>
    )
}
</script>
<template>
    <slot v-bind="{ renderButton, renderConfirm }">
        <renderButton />
        <renderConfirm />
    </slot>
    <!-- <VarsityInlineConfirmButton :controller="confirm"> -->
    <!--     {{ $t("@tasks:tasks.championship_registration.wizard.reset_registration.button") }} -->
    <!-- </VarsityInlineConfirmButton> -->

    <!-- <VarsityInlineConfirm :controller="confirm"> -->
    <!--     <template #confirmation> -->
    <!--         {{ $t("@tasks:tasks.championship_registration.wizard.reset_registration.confirmation") }} -->
    <!--     </template> -->
    <!--     <template #success> -->
    <!--         {{ $t("@tasks:tasks.championship_registration.wizard.reset_registration.success") }} -->
    <!--     </template> -->
    <!-- </VarsityInlineConfirm> -->
</template>
